__webpack_require__.p = "/a/courses/high_contrast_cards_for_newborns/";